import { CommonLockableAmountField } from 'components/common-form/builder/form/node/field/LockableAmountField/CommonLockableAmount';
import { NotionalTradedSoFarAmountField } from 'components/common-form/builder/form/node/field/LockableAmountField/NotionalTradedSoFarAmountField';
import { ProductNodeBuilderProps } from 'components/common-form/builder/form/node/ProductNodeBuilder.model';

export function LockableAmountField(props: ProductNodeBuilderProps) {
  if (props.node.id === 'NotionalTradedSoFar') {
    return <NotionalTradedSoFarAmountField {...props} />;
  }
  return <CommonLockableAmountField {...props} />;
}
